import { render } from "./SabreJr.vue?vue&type=template&id=17cea4d5&scoped=true"
import script from "./SabreJr.vue?vue&type=script&lang=js"
export * from "./SabreJr.vue?vue&type=script&lang=js"

import "./SabreJr.vue?vue&type=style&index=0&id=17cea4d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17cea4d5"]])

export default __exports__